import { AppConfig } from '@shared/definitions';

export const appConfig: AppConfig = {
  /* PAUL-3246 has not rolled this app over yet — `config` with the historical minute keeps
     today's behaviour until its backend is checked for JWT access tokens. */
  tokenExpiration: { source: 'config', minutes: 1 },
  app: 'language_school-client',
  appTitle: 'Language School Client',
  email: '',
  gtm: '',
  logo: {
    light: '/logo/logo-light-st.svg',
    dark: '/logo/logo-light-st.svg',
    mark: '/logo/logo-light-st.svg',
  },

  language: {
    defaultLanguage: 'en',
    languages: [
      { code: 'en', iconFlagPath: 'assets/flags/united-kingdom.png' },
      { code: 'nl', iconFlagPath: 'assets/flags/netherlands.png' },
    ],
  },
  disabledAuthPopup: true,
};
